import React, { useContext, useEffect, useState } from "react";
import { getSampleSize } from "common/api";
import { useScreenSize } from "common/hooks";
import { getInRangeItems, getAllItemsNotAggregated } from "./utils";
import { Chart } from "./Chart";
import ActionsContext from "common/ActionsContext";
import BqnContext from "common/BqnContext";
import { getIndexes } from "common/utils";
import { dateTimeParser, parseFloatOrNull } from "./api";
import styled from "styled-components";
import { HOURS_TO_PERIOD } from "common/constants";

const ChartContainer = styled.div`
  margin-bottom: 0px;
`;

function getResult(attrs, rows, headerIndex, bqns) {
  const result = {};

  attrs.forEach((attr) => {
    result[attr] = {
      items: [],
    };
  });

  for (let row of rows) {
    const words = row.trim().split(/\s+/);
    const time = dateTimeParser(words[headerIndex['TIME']]);

    attrs.forEach((attr) => {
      let item = { time };

      bqns.forEach((bqn) => {
        item[bqn.bqnId.toString()] = parseFloatOrNull(words[headerIndex[`${attr}-${bqn.bqnId}`]]);
      });

      result[attr].items.push(item);
    });
  }
  return result;
};

const ClusterChart = ({
  titles,
  yAxisUnits,
  yTooltipFormat,
  range,
  hours,
  command,
  attrs,
  interactionData,
  setInteractionData,
  fields,
  selection,
  doToggle,
  type
}) => {
  const actions = useContext(ActionsContext);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const { width: windowWidth } = useScreenSize();
  const POINTS_PER_TILE_CHART = windowWidth / 2;
  const { bqns } = useContext(BqnContext);
  const [metricCluster, setMetricCluster] = useState("RTT-MIN-DN-ms");
  const period = HOURS_TO_PERIOD[hours];

  const sampleSize = range
    ? getSampleSize(range, POINTS_PER_TILE_CHART, period)
    : 1;

  useEffect(() => {
    load();

    return actions.recv("do-load", load);
  }, [hours]);
  

  function load() {
    setLoading(true);
    ifCl.run(command).then(response => {
      const [head, ...rows] = response.trim().split("\n");
      const headerIndex = getIndexes(head);
      const result = getResult(attrs, rows, headerIndex, bqns);
      setResult(result);
      setTimeout(() => {
        setLoading(false);
      }, 2000)
    });
  }
  const attrsToDisplay = type === "latency" ? [metricCluster] : attrs;
  
  
  return attrsToDisplay.map((attr, index) => {
    const items = getAllItemsNotAggregated(result?.[attr], fields, range);
    const inRangeItems = getInRangeItems(items, range, fields, sampleSize);

    return (
      <ChartContainer key={`chart-${attr}-${index}`}>
        <Chart
          title={titles[index]}
          fields={selection}
          hours={hours}
          items={inRangeItems}
          yAxisUnits={yAxisUnits}
          yTooltipFormat={yTooltipFormat}
          range={range}
          interactionData={interactionData}
          setInteractionData={setInteractionData}
          windowWidth={windowWidth}
          loading={loading}
          selection={selection}
          doToggle={doToggle}
          type={`${type}-cluster`}
          metricCluster={metricCluster}
          setMetricCluster={setMetricCluster}
          metricChoices={[
            { value: "all", label: "All" },
            { value: "RTT-80%-DN-ms", label: "P80-80th percentile" },
            { value: "RTT-MED-DN-ms", label: "P50-Median" },
            { value: "RTT-MIN-DN-ms", label: "Mean-Min" },
          ]}
        />
      </ChartContainer>
    );
  });
};

export default ClusterChart;
